import { Sparkle } from "lucide-react";

const ITEMS = [
    "Dal Potenziale al Risultato",
    "Mental Coaching",
    "From Potential to Performance",
    "Formazione & Crescita",
    "Leadership",
];

export const Marquee = () => {
    const row = [...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="marquee-banner"
            className="overflow-hidden border-y border-[rgba(226,192,117,0.16)] py-5"
        >
            <div className="marquee-track flex w-max items-center">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center">
                        {row.map((text, i) => (
                            <span key={`${half}-${i}`} className="flex items-center whitespace-nowrap">
                                <span className="font-display px-8 text-xl italic text-[#e2c075]/85">
                                    {text}
                                </span>
                                <Sparkle className="h-3 w-3 shrink-0 text-[#e2c075]/45" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
